import { useMemo, useState } from "react";
import { articles, categories } from "../../../mocks/trendData";

const catIcons: Record<string, string> = {
  明星动态: "ri-star-smile-line",
  综艺现场: "ri-mic-line",
  网红圈: "ri-user-heart-line",
  直播切片: "ri-vidicon-line",
  品牌八卦: "ri-coupon-3-line",
  全部: "ri-grid-fill",
};

export default function CategorySection() {
  const [active, setActive] = useState("全部");
  const [expanded, setExpanded] = useState<number | null>(null);

  const list = useMemo(
    () => (active === "全部" ? articles : articles.filter((a) => a.category === active)),
    [active]
  );

  return (
    <section id="category" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-archive-2-line" aria-hidden="true"></i> 栏目分类
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              想吃哪个瓜，点进来挑
            </h2>
          </div>
        </div>

        <div className="mb-6 flex flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setActive(cat)}
              className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-1 py-1 transition-colors ${
                active === cat ? "bg-primary-500 text-white" : "text-foreground-600 hover:bg-background-200"
              }`}
            >
              <span className="rounded-full px-4 py-2 text-sm font-medium">
                <i className={`${catIcons[cat] || "ri-grid-fill"} mr-1.5`} aria-hidden="true"></i>
                {cat}
              </span>
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((art) => {
            const isOpen = expanded === art.id;
            return (
              <article
                key={art.id}
                className="flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-transform hover:-translate-y-0.5"
              >
                <div className="relative aspect-[4/3] w-full overflow-hidden">
                  <img
                    src={art.cover}
                    alt={art.title}
                    className="h-full w-full object-cover object-top transition-transform duration-300 hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-[11px] text-white backdrop-blur-sm">
                    {art.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <span className="text-xs font-medium text-primary-700">{art.category}</span>
                  <button
                    type="button"
                    onClick={() => setExpanded(isOpen ? null : art.id)}
                    className="mt-1.5 cursor-pointer text-left text-sm font-semibold leading-snug text-foreground-950 transition-colors hover:text-primary-700 md:text-base"
                  >
                    {art.title}
                  </button>
                  {isOpen && (
                    <p className="mt-2 text-xs leading-relaxed text-foreground-500">{art.summary}</p>
                  )}
                  <div className="mt-auto flex items-center justify-between pt-3">
                    <span className="text-xs text-foreground-400">
                      <i className="ri-calendar-line mr-1" aria-hidden="true"></i>
                      {art.date}
                    </span>
                    <span className="text-xs text-foreground-400">
                      <i className="ri-eye-line mr-1" aria-hidden="true"></i>
                      {(art.views / 1000).toFixed(1)}w
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {active !== "全部" && list.length === 0 && (
          <p className="py-10 text-center text-sm text-foreground-400">该栏目内容整理中，敬请期待。</p>
        )}
      </div>
    </section>
  );
}